import React from "react";
import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WaActions = ({ m }) => {
  const copy = () => { navigator.clipboard?.writeText(m.body); toast.success("Messaggio copiato"); };
  const open = () => {
    navigator.clipboard?.writeText(m.body);
    const phone = (m.phone || "").replace(/\D/g, "").replace(/^00/, "");
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(m.body)}`, "_blank");
  };
  return (
    <div className="mt-3 flex flex-wrap gap-2">
      <Button size="sm" variant="outline" data-testid={`wa-copy-${m.id}`} onClick={copy}>
        <Copy className="mr-1 h-3.5 w-3.5" /> Copia
      </Button>
      <Button size="sm" variant="outline" data-testid={`wa-open-${m.id}`} onClick={open}>
        <ExternalLink className="mr-1 h-3.5 w-3.5" /> Apri WhatsApp
      </Button>
    </div>
  );
};
